import { useEffect, useState } from "react";

const links = [
  { href: "#columns", label: "核查栏目" },
  { href: "#reports", label: "最新结论" },
  { href: "#debunk", label: "辟谣专区" },
  { href: "#method", label: "核查流程" },
  { href: "#criteria", label: "鉴定标准" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-shield-check-line text-lg md:text-xl"></i>
            </span>
            <span className="leading-none">
              <span className="block font-heading font-bold text-lg md:text-xl text-foreground-950 tracking-tight">
                求真核查站
              </span>
              <span className="block mt-1 text-[11px] md:text-xs text-foreground-600 font-medium">
                在线黑料事实核查
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-700 font-medium transition-colors rounded-md whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#contact"
              className="hidden md:inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2 text-sm font-medium transition-colors"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </a>
            <button
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 transition-colors"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/98 px-4 py-3">
          <nav className="flex flex-col">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-2 py-3 text-sm font-medium text-foreground-800 border-b border-background-100 hover:text-primary-700 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2.5 text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-send-plane-line"></i>
              提交线索
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}